export default "__VITE_ASSET__DqhDbH0w__"